import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { PhoneCall, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PhoneLookup() {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    const digits = q.replace(/\D/g, "");
    if (digits.length < 4) { setRows([]); return; }
    setLoading(true);
    const t = setTimeout(() => {
      axios.get(`${API}/members/lookup`, { params: { phone: digits } })
        .then(r => setRows(r.data))
        .finally(() => setLoading(false));
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.14em] text-slate-500 mb-2">Sorgu</div>
        <h1 className="text-3xl font-extrabold tracking-tight text-slate-900">Telefon Sorgulama</h1>
        <p className="text-slate-600 mt-1 text-sm">Telefon numarasını yazın; ortağın şirket ve hisse bilgileri anında listelenir.</p>
      </div>

      <div className="crisp-card p-6">
        <div className="relative">
          <PhoneCall size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            data-testid="phone-input"
            autoFocus
            value={q}
            onChange={e => setQ(e.target.value)}
            placeholder="Örn: 532 407 74 66"
            className="w-full pl-12 pr-4 py-4 rounded-md border border-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-900 text-lg font-mono-nums"
          />
        </div>
        <div className="mt-2 text-xs text-slate-500">En az 4 rakam girin.</div>
      </div>

      <div className="space-y-3">
        {loading && <div className="text-slate-500 text-sm">Aranıyor...</div>}
        {!loading && q.replace(/\D/g,"").length >= 4 && rows.length === 0 && (
          <div className="crisp-card p-8 text-center text-slate-500 text-sm">
            <Search className="mx-auto mb-2 text-slate-400" size={22} />
            Bu numarayla eşleşen ortak bulunamadı.
          </div>
        )}
        {rows.map((m, i) => (
          <div key={m.id} data-testid={`phone-result-${m.id}`}
               onClick={() => nav(`/ortak/${m.id}`)}
               className="crisp-card p-5 cursor-pointer hover:shadow-md hover:-translate-y-[2px] transition-transform stagger-row"
               style={{ animationDelay: `${i*40}ms` }}>
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div>
                <div className="text-xs uppercase tracking-widest text-slate-500 mb-1">
                  {m.status === "departed" ? "Ayrılan" : "Aktif"}
                </div>
                <div className="text-lg font-bold text-slate-900">{m.ad_soyad}</div>
                <div className="text-xs text-slate-500 font-mono-nums mt-1">
                  {[m.tel1, m.tel2, m.gsm1, m.gsm2].filter(Boolean).join(" · ") || "—"}
                </div>
              </div>
              <div className="flex flex-wrap items-center gap-2">
                {m.misas_hisse > 0 && <span className="inline-flex company-misas rounded-full px-2.5 py-1 text-xs font-bold">Misaş · {m.misas_hisse} hisse</span>}
                {m.mis_holding_hisse > 0 && <span className="inline-flex company-mh rounded-full px-2.5 py-1 text-xs font-bold">Mis Holding · {m.mis_holding_hisse} hisse</span>}
                {m.koop_hisse > 0 && <span className="inline-flex company-koop rounded-full px-2.5 py-1 text-xs font-bold">Koop. · {m.koop_hisse} hisse</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
